export default "__VITE_ASSET__Dxq9pFLL__"